import React from 'react';
import { Link } from 'react-router-dom';
import { Hash } from 'lucide-react';

interface HashtagLinkProps {
  hashtag: string;
  count?: number;
  className?: string;
  showIcon?: boolean;
  showCount?: boolean;
}

export const HashtagLink: React.FC<HashtagLinkProps> = ({
  hashtag,
  count,
  className = '',
  showIcon = true,
  showCount = false
}) => {
  const cleanHashtag = hashtag.replace('#', '');

  return (
    <Link
      to={`/hashtag/${cleanHashtag}`}
      className={`inline-flex items-center text-blue-600 hover:text-blue-700 transition-colors ${className}`}
    >
      {showIcon && <Hash className="h-3 w-3 mr-0.5" />}
      <span>{cleanHashtag}</span>
      {showCount && count !== undefined && (
        <span className="ml-1 text-xs text-gray-500">({count})</span>
      )}
    </Link>
  );
};